"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableMenuIsLocked_1 = require("../../../../../../shared/components/table_menus/TableMenuIsLocked");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var TableCheckActionIconSelect_1 = require("../../../../../../shared/components/table_actions/TableCheckActionIconSelect");
var GwsGameProviderGamesList = /** @class */ (function (_super) {
    __extends(GwsGameProviderGamesList, _super);
    function GwsGameProviderGamesList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchNameInput = null;
        return _this;
    }
    GwsGameProviderGamesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total,
                filters: data.groups_filter,
                loading: false
            });
        });
        this.setState({
            data: [],
            filters: [],
            loading: true,
            totalRows: 0,
            searchNameFilter: [],
            searchNameValue: ""
        }, function () {
            _this.props.data.LoadData(_this.props.recordKey.key);
        });
        this.props.state.setExtBreadCrumbPath(["Список игр"]);
    };
    GwsGameProviderGamesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    GwsGameProviderGamesList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps) {
            if (nextProps.recordKey != this.props.recordKey) {
                nextProps.data.LoadData(nextProps.recordKey.key);
            }
        }
    };
    GwsGameProviderGamesList.prototype.doLockAction = function (key, title, lock) {
        this.props.data.SetGwsGameProviderGameIsLocked(key, lock, function () {
            if (lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0418\u0433\u0440\u0430 ",
                    React.createElement("b", null,
                        "[",
                        title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0418\u0433\u0440\u0430 ",
                    React.createElement("b", null,
                        "[",
                        title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430"));
            }
        });
    };
    /* ******************************************WAGER BEGIN**************************************************** */
    GwsGameProviderGamesList.prototype.getWagerPercentArray = function () {
        var _ret = [];
        for (var i = 0; i <= 10; i++) {
            _ret.push(React.createElement(antd_1.Menu.Divider, { key: i + 100 }));
            _ret.push(React.createElement(antd_1.Menu.Item, { key: "" + i * 10 },
                React.createElement(FontAwesome_1.FA, { icon: "percent", left: true }),
                "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C ",
                i * 10,
                " % "));
        }
        return _ret;
    };
    GwsGameProviderGamesList.prototype.getWagerActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doWagerAction(e, record); } }, this.getWagerPercentArray()));
    };
    GwsGameProviderGamesList.prototype.doWagerAction = function (e, record) {
        var _percent = 0;
        _percent = parseInt(e.key, 10);
        this.props.data.SetGwsGameProviderGameWagerPercent(record.key, _percent, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041F\u0440\u043E\u0446\u0435\u043D\u0442 \u043E\u0442\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u0432 \u0432\u0435\u0439\u0434\u0436\u0435\u0440 \u0434\u043B\u044F \u0438\u0433\u0440\u044B ",
                React.createElement("b", null,
                    "[",
                    record.game_title,
                    "]"),
                " \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
        });
    };
    /* ******************************************WAGER END**************************************************** */
    /* ******************************************WITHDRAW BEGIN**************************************************** */
    GwsGameProviderGamesList.prototype.getWithdrawPercentArray = function () {
        var _ret = [];
        for (var i = 0; i <= 10; i++) {
            _ret.push(React.createElement(antd_1.Menu.Divider, { key: i + 100 }));
            _ret.push(React.createElement(antd_1.Menu.Item, { key: "" + i * 10 },
                React.createElement(FontAwesome_1.FA, { icon: "percent", left: true }),
                "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C ",
                i * 10,
                " % "));
        }
        return _ret;
    };
    GwsGameProviderGamesList.prototype.getWithdrawActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doWithdrawAction(e, record); } }, this.getWithdrawPercentArray()));
    };
    GwsGameProviderGamesList.prototype.doWithdrawAction = function (e, record) {
        var _percent = 0;
        _percent = parseInt(e.key, 10);
        this.props.data.SetGwsGameProviderGameWithdrawPercent(record.key, _percent, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041F\u0440\u043E\u0446\u0435\u043D\u0442 \u043E\u0442\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u0432 \u0441\u043D\u044F\u0442\u0438\u0435 \u0434\u043B\u044F \u0438\u0433\u0440\u044B ",
                React.createElement("b", null,
                    "[",
                    record.game_title,
                    "]"),
                " \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
        });
    };
    /* ******************************************WITHDRAW END**************************************************** */
    /* ****************************************JACKPOT BEGIN**************************************************** */
    GwsGameProviderGamesList.prototype.getJackpotPercentArray = function () {
        var _ret = [];
        for (var i = 0; i <= 10; i++) {
            _ret.push(React.createElement(antd_1.Menu.Divider, { key: i + 100 }));
            _ret.push(React.createElement(antd_1.Menu.Item, { key: "" + i * 10 },
                React.createElement(FontAwesome_1.FA, { icon: "percent", left: true }),
                "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C ",
                i * 10,
                " % "));
        }
        return _ret;
    };
    GwsGameProviderGamesList.prototype.getJackpotActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doJackpotAction(e, record); } }, this.getJackpotPercentArray()));
    };
    GwsGameProviderGamesList.prototype.doJackpotAction = function (e, record) {
        var _percent = 0;
        _percent = parseInt(e.key, 10);
        this.props.data.SetGwsGameProviderGameJackpotPercent(record.key, _percent, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041F\u0440\u043E\u0446\u0435\u043D\u0442 \u043E\u0442\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u0432 \u0434\u0436\u0435\u043A\u043F\u043E\u0442 \u0434\u043B\u044F \u0438\u0433\u0440\u044B ",
                React.createElement("b", null,
                    "[",
                    record.game_title,
                    "]"),
                " \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
        });
    };
    /* ****************************************JACKPOT END**************************************************** */
    /* ****************************************TOURNAMENT BEGIN**************************************************** */
    GwsGameProviderGamesList.prototype.getTournamentPercentArray = function () {
        var _ret = [];
        for (var i = 0; i <= 10; i++) {
            _ret.push(React.createElement(antd_1.Menu.Divider, { key: i + 100 }));
            _ret.push(React.createElement(antd_1.Menu.Item, { key: "" + i * 10 },
                React.createElement(FontAwesome_1.FA, { icon: "percent", left: true }),
                "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C ",
                i * 10,
                " % "));
        }
        return _ret;
    };
    GwsGameProviderGamesList.prototype.getTournamentActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doTournamentAction(e, record); } }, this.getTournamentPercentArray()));
    };
    GwsGameProviderGamesList.prototype.doTournamentAction = function (e, record) {
        var _percent = 0;
        _percent = parseInt(e.key, 10);
        this.props.data.SetGwsGameProviderGameTournamentPercent(record.key, _percent, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041F\u0440\u043E\u0446\u0435\u043D\u0442 \u043E\u0442\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u0432 \u0442\u0443\u0440\u043D\u0438\u0440 \u0434\u043B\u044F \u0438\u0433\u0440\u044B ",
                React.createElement("b", null,
                    "[",
                    record.game_title,
                    "]"),
                " \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
        });
    };
    /* ****************************************TOURNAMENT END**************************************************** */
    /* ****************************************POINTS BEGIN**************************************************** */
    GwsGameProviderGamesList.prototype.getPointsPercentArray = function () {
        var _ret = [];
        for (var i = 0; i <= 10; i++) {
            _ret.push(React.createElement(antd_1.Menu.Divider, { key: i + 100 }));
            _ret.push(React.createElement(antd_1.Menu.Item, { key: "" + i * 10 },
                React.createElement(FontAwesome_1.FA, { icon: "percent", left: true }),
                "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C ",
                i * 10,
                " % "));
        }
        return _ret;
    };
    GwsGameProviderGamesList.prototype.getPointsActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doPointsAction(e, record); } }, this.getPointsPercentArray()));
    };
    GwsGameProviderGamesList.prototype.doPointsAction = function (e, record) {
        var _percent = 0;
        _percent = parseInt(e.key, 10);
        this.props.data.SetGwsGameProviderGamePointsPercent(record.key, _percent, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041F\u0440\u043E\u0446\u0435\u043D\u0442 \u043E\u0442\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u0432 \u043F\u043E\u0439\u043D\u0442\u044B \u0434\u043B\u044F \u0438\u0433\u0440\u044B ",
                React.createElement("b", null,
                    "[",
                    record.game_title,
                    "]"),
                " \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
        });
    };
    /* ****************************************POINTS END**************************************************** */
    /* ****************************************LEVELS BEGIN**************************************************** */
    GwsGameProviderGamesList.prototype.getLevelsPercentArray = function () {
        var _ret = [];
        for (var i = 0; i <= 10; i++) {
            _ret.push(React.createElement(antd_1.Menu.Divider, { key: i + 100 }));
            _ret.push(React.createElement(antd_1.Menu.Item, { key: "" + i * 10 },
                React.createElement(FontAwesome_1.FA, { icon: "percent", left: true }),
                "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C ",
                i * 10,
                " % "));
        }
        return _ret;
    };
    GwsGameProviderGamesList.prototype.getLevelsActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doLevelsAction(e, record); } }, this.getLevelsPercentArray()));
    };
    GwsGameProviderGamesList.prototype.doLevelsAction = function (e, record) {
        var _percent = 0;
        _percent = parseInt(e.key, 10);
        this.props.data.SetGwsGameProviderGameLevelsPercent(record.key, _percent, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041F\u0440\u043E\u0446\u0435\u043D\u0442 \u043E\u0442\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u0432 \u0443\u0440\u043E\u0432\u043D\u0438 \u0434\u043B\u044F \u0438\u0433\u0440\u044B ",
                React.createElement("b", null,
                    "[",
                    record.game_title,
                    "]"),
                " \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
        });
    };
    /* ****************************************LEVELS END**************************************************** */
    GwsGameProviderGamesList.prototype.doSetIsBonus = function (record, isBonus) {
        this.props.data.SetGwsGameProviderGameIsBonus(record.key, isBonus);
    };
    GwsGameProviderGamesList.prototype.doSetIsHot = function (record, isHot) {
        this.props.data.SetGwsGameProviderGameIsHot(record.key, isHot);
    };
    GwsGameProviderGamesList.prototype.doSetIsFreespin = function (record, isFS) {
        this.props.data.SetGwsGameProviderGameIsFreespin(record.key, isFS);
    };
    GwsGameProviderGamesList.prototype.onChangeNameFilter = function (e) {
        this.setState({ searchNameValue: e.target.value });
    };
    GwsGameProviderGamesList.prototype.onConfirmNameFilter = function () {
        this.setState({ searchNameFilter: [this.state.searchNameValue] });
    };
    GwsGameProviderGamesList.prototype.onClearNameFilter = function () {
        this.setState({ searchNameFilter: [], searchNameValue: "" });
    };
    GwsGameProviderGamesList.prototype.getColumns = function () {
        var _this = this;
        var _name_filter = this.state.searchNameFilter;
        return [
            {
                title: 'Название',
                dataIndex: this.props.data.dk_game_title,
                key: this.props.data.dk_game_title,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchNameInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0438\u043C\u0435\u043D\u0438", value: _this.state.searchNameValue, onChange: _this.onChangeNameFilter.bind(_this), onPressEnter: function () { _this.onConfirmNameFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmNameFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearNameFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _name_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.game_title.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchNameInput.focus();
                        });
                    }
                }
            }, {
                title: 'Провайдер',
                dataIndex: this.props.data.dk_game_group_title,
                key: this.props.data.dk_game_group_title,
                filters: this.state.filters,
                filterMultiple: true,
                onFilter: function (value, record) { return record.game_group_title.includes(value); },
                width: 150,
            }, {
                title: 'Доступна в бонусах c',
                children: [{
                        title: 'вейджером',
                        dataIndex: this.props.data.dk_game_is_bonus,
                        key: this.props.data.dk_game_is_bonus,
                        align: "center",
                        render: function (text, record, idx) {
                            return (React.createElement(TableCheckActionIconSelect_1.default, { selected: record.game_is_bonus, hint: record.game_is_bonus ? "Снять метку \"Доступна в бонусах с вейджером\"" : "Добавить метку \"Доступна в бонусах с вейджером\"", icon: "gift", onClick: function (checked) {
                                    _this.doSetIsBonus(record, !checked);
                                } }));
                        },
                        width: 80,
                    }, {
                        title: 'фриспинами',
                        dataIndex: this.props.data.dk_game_is_freespin,
                        key: this.props.data.dk_game_is_freespin,
                        align: "center",
                        render: function (text, record, idx) {
                            return (React.createElement(TableCheckActionIconSelect_1.default, { selected: record.game_is_freespin, hint: record.game_is_freespin ? "Снять метку \"Доступна в бонусах с фриспинами\"" : "Добавить метку \"Доступна в бонусах с фриспинами\"", icon: "sync", onClick: function (checked) {
                                    _this.doSetIsFreespin(record, !checked);
                                } }));
                        },
                        width: 80,
                    }]
            }, {
                title: 'Заблокирована',
                dataIndex: this.props.data.dk_game_is_locked,
                key: this.props.data.dk_game_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать", text: "Да" }, unlockedTexts: { menu: "Разблокировать", text: "Нет" }, record: { key: record.key, title: record.game_title, locked: record.game_is_locked }, onLockClick: _this.doLockAction.bind(_this) }));
                },
                width: 100,
            }, {
                title: 'Процент отчисления в:',
                children: [{
                        title: 'вейджер',
                        dataIndex: this.props.data.dk_wager_percent,
                        key: this.props.data.dk_wager_percent,
                        align: "center",
                        render: function (text, record, idx) {
                            return (React.createElement(antd_1.Dropdown, { overlay: _this.getWagerActionsDropDownMenu(record), trigger: ['click'] },
                                React.createElement(antd_1.Button, { style: { width: 75, minWidth: 75, maxWidth: 75 } },
                                    record.wager_percent,
                                    " % ",
                                    React.createElement(antd_1.Icon, { type: "down" }))));
                        },
                        width: 80,
                    }, {
                        title: 'снятие',
                        dataIndex: this.props.data.dk_withdraw_percent,
                        key: this.props.data.dk_withdraw_percent,
                        align: "center",
                        render: function (text, record, idx) {
                            return (React.createElement(antd_1.Dropdown, { overlay: _this.getWithdrawActionsDropDownMenu(record), trigger: ['click'] },
                                React.createElement(antd_1.Button, { style: { width: 75, minWidth: 75, maxWidth: 75 } },
                                    record.withdraw_percent,
                                    " % ",
                                    React.createElement(antd_1.Icon, { type: "down" }))));
                        },
                        width: 80,
                    }, {
                        title: 'джекпот',
                        dataIndex: this.props.data.dk_jackpot_percent,
                        key: this.props.data.dk_jackpot_percent,
                        align: "center",
                        render: function (text, record, idx) {
                            return (React.createElement(antd_1.Dropdown, { overlay: _this.getJackpotActionsDropDownMenu(record), trigger: ['click'] },
                                React.createElement(antd_1.Button, { style: { width: 75, minWidth: 75, maxWidth: 75 } },
                                    record.jackpot_percent,
                                    " % ",
                                    React.createElement(antd_1.Icon, { type: "down" }))));
                        },
                        width: 80,
                    } /*, {
                        title: 'турнир',
                        dataIndex: this.props.data.dk_tournament_percent,
                        key: this.props.data.dk_tournament_percent,
                        align: "center",
                        render: (text, record, idx) => {
                            return (
                                <Dropdown overlay={this.getTournamentActionsDropDownMenu(record)} trigger={['click']}>
                                    <Button style={{ width: 75, minWidth: 75, maxWidth: 75 }}>
                                        {record.tournament_percent} % <Icon type="down" />
                                    </Button>
                                </Dropdown>
                            )
                        },
                        width: 80,
                    }*/,
                    {
                        title: 'пойнты',
                        dataIndex: this.props.data.dk_points_percent,
                        key: this.props.data.dk_points_percent,
                        align: "center",
                        render: function (text, record, idx) {
                            return (React.createElement(antd_1.Dropdown, { overlay: _this.getPointsActionsDropDownMenu(record), trigger: ['click'] },
                                React.createElement(antd_1.Button, { style: { width: 75, minWidth: 75, maxWidth: 75 } },
                                    record.points_percent,
                                    " % ",
                                    React.createElement(antd_1.Icon, { type: "down" }))));
                        },
                        width: 80,
                    }, {
                        title: 'уровни',
                        dataIndex: this.props.data.dk_level_percent,
                        key: this.props.data.dk_level_percent,
                        align: "center",
                        render: function (text, record, idx) {
                            return (React.createElement(antd_1.Dropdown, { overlay: _this.getLevelsActionsDropDownMenu(record), trigger: ['click'] },
                                React.createElement(antd_1.Button, { style: { width: 75, minWidth: 75, maxWidth: 75 } },
                                    record.level_percent,
                                    " % ",
                                    React.createElement(antd_1.Icon, { type: "down" }))));
                        },
                        width: 80,
                    }]
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteGameClick(record); } }))); },
                width: 80
            }
        ];
    };
    GwsGameProviderGamesList.prototype.onDeleteGameClick = function (record) {
        this.props.data.DeleteGwsGameProviderGame(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0418\u0433\u0440\u0430 ",
                React.createElement("b", null,
                    "[",
                    record.game_title,
                    "]"),
                " \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430"));
        });
    };
    GwsGameProviderGamesList.prototype.onToolBarClick = function (action) {
        var _this = this;
        if (action === "refresh") {
            this.setState({ loading: true }, function () {
                _this.props.data.LoadData(_this.props.recordKey.key, function () {
                    _this.setState({ loading: false });
                });
            });
        }
        if (action === "back") {
            if (this.props.onGoBack) {
                this.props.onGoBack();
            }
        }
    };
    GwsGameProviderGamesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { back: "Вернуться", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { size: "small", bordered: true, columns: this.getColumns(), dataSource: this.state.data, loading: this.state.loading, locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, pagination: {
                    defaultPageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return (React.createElement("div", { style: { margin: 0, display: "flex", flexDirection: "row", flexWrap: "nowrap" } },
                    React.createElement("div", { style: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            flexWrap: "nowrap"
                        }, key: "t_1" },
                        React.createElement("div", { key: "c_1" },
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", { key: "c_2" },
                            React.createElement("b", null, "Backend id:"),
                            " [",
                            record.game_backend_id,
                            "]"),
                        React.createElement("div", { key: "c_3" },
                            React.createElement("b", null, "\u041A\u043E\u043B-\u0432\u043E \u043B\u0438\u043D\u0438\u0439:"),
                            " [",
                            record.game_lines_count,
                            "]"),
                        React.createElement("div", { key: "c_4" },
                            React.createElement("b", null, "\u0428\u0438\u0440\u0438\u043D\u0430 \u0438\u0433\u0440\u044B:"),
                            " [",
                            record.game_desktop_w,
                            "] px"),
                        React.createElement("div", { key: "c_5" },
                            React.createElement("b", null, "\u0412\u044B\u0441\u043E\u0442\u0430 \u0438\u0433\u0440\u044B:"),
                            " [",
                            record.game_desktop_h,
                            "] px"),
                        React.createElement("div", { key: "c_6" },
                            React.createElement("b", null, "\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430:"),
                            " [",
                            record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                            "]"),
                        React.createElement("div", { key: "c_7" },
                            React.createElement("b", null, "Url:"),
                            " [",
                            record.game_url,
                            "]")),
                    React.createElement("div", { key: "t_2" },
                        React.createElement("img", { style: { marginLeft: "20px" }, height: 110, src: record.game_icon_full_url })),
                    React.createElement("div", { key: "t_23" },
                        React.createElement("img", { style: { marginLeft: "20px" }, height: 110, src: record.game_icon_full_url_1 })))); }, scroll: { x: true } })));
    };
    return GwsGameProviderGamesList;
}(React.Component));
exports.default = GwsGameProviderGamesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gws_gameproviders_list/ui/component/GwsGameProviderGamesList.tsx
// module id = 1859
// module chunks = 0